import React, { useCallback, useState, memo } from 'react';
import { toastr } from 'react-redux-toastr';
import { Modal, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeEventNote } from '../../../../../shared/api/action/AlertActions';
import CustomButton from '../../CustomButton';
import momenttz from "../../helpers/momenttz";
import { formatWithZoneAbbrNode } from '../../helpers/timeDisplaySettings';

const EventNoteModal = (props) => {
	const dispatch = useDispatch();
	const { onSave, event, show, onHide, allowDeviceTz } = props;
	const user = useSelector(state => state.user);
	const { t } = useTranslation();
	const [content, setContent] = useState('');
	const [reviewed, setReviewed] = useState(!!event?.has_review || false);

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	const hasPermissions = () => {
		const userRole = user.user.roles[0]

		if (userRole === 'sales_demo'
			|| userRole === 'reviewer'
			|| (userRole === 'user' && event && event.created_by ? event.created_by !== user.user.id : null)
		) {
			return false
		}

		return true
	}

	const fillForm = (e) => {
		if (hasPermissions()) {
			const { target } = e;
			const value = target.type === 'checkbox' ? target.checked : target.value;
			setContent(value);
		}
	}

	const handleCheckboxChange = (e) => {
		if (hasPermissions()) {
			const value = e.target.checked;
			setReviewed(value);
		}
	}

	const onEnterModal = () => {
		const content = event.event_notes || event.custom_event_type || '';

		setContent(content);
	}

	const Save = () => {
		toggleLoader(true);

		changeEventNote({
			event_id: event.id,
			partner_name: props.partner_name,
			company_name: props.company_name,
			description: content,
			has_review: reviewed
		})
			.then((res, err) => {
				toggleLoader(false)
				onSave({
					note: content,
					reviewed
				})
				toastr.success('', t('modals.eventNoteModal.toastrNoteAdded'))
			})
			.catch((error) => {
				toggleLoader(false);
				onHide();
				console.log(error);

				let errDescription = t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	let opts = {};
	if (!hasPermissions()) {
		opts.readOnly = 'readOnly';
	}

	return (
		<Modal
			show={show}
			onHide={onHide}
			onEnter={onEnterModal}
			className="modal-lg-size"
			dialogClassName="event-note-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">{t('modals.eventNoteModal.titleNote')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{event?.last_reviewed_name || event?.last_reviewed ? (
					<div className="mb-4 event-modify-info">
						{event?.last_reviewed_name ? (
							<p>
								<strong>{t('modals.eventNoteModal.createdBy')}</strong>
								&nbsp;{event.last_reviewed_name}
							</p>
						) : ''}
						{event?.last_reviewed ? (
							<p>
								<strong>{t('modals.eventNoteModal.lastUpdated')}</strong>
								&nbsp;{formatWithZoneAbbrNode(momenttz(`${event.last_reviewed}+00`, allowDeviceTz ? event?.device_tz : undefined), 'M/DD/YYYY hh:mm:ss A')}
							</p>
						) : ''}
					</div>
				) : ''}
				<Form>
					<Form.Group className="mb-2">
						<Form.Control
							className="notes-textarea"
							as="textarea"
							name="content"
							value={content}
							rows={4}
							onChange={fillForm}
							maxLength={250}
							{...opts}
						/>
					</Form.Group>
					<div className="mb-3">
						<Form.Check
							disabled={!hasPermissions()}
							className="mark-as-reviewed"
							type="checkbox"
							id="markAsReviewed"
							checked={reviewed}
							label={t('modals.eventNoteModal.markAsReviewed')}
							onChange={handleCheckboxChange}
						/>
						<span>{content.length}/250</span>
					</div>
				</Form>
			</Modal.Body>
			<Modal.Footer bsPrefix="default-modal-footer modal-footer">
				<CustomButton onClick={() => onHide()}
					variant="primary-outline">{t('modals.eventNoteModal.buttonBack')}</CustomButton>
				{hasPermissions() &&
					<CustomButton onClick={Save} variant="primary">{t('modals.eventNoteModal.buttonSave')}</CustomButton>}
			</Modal.Footer>
		</Modal>
	);
};

export default memo(EventNoteModal);
